module.exports = __webpack_public_path__ + "img/md-star.0ba291d7.svg";